export { AtnGlRecordSlideoutComponent as Component } from './gl-record-slideout.component'
